import {Component, Input, OnInit} from '@angular/core';
import {ModalController} from '@ionic/angular';
import {DocumentModel} from '../../models/document.model';
import {ServiceJobDTOModel} from '../../models/service-job-DTO.model';
import {LokijsService} from '../../services/database/lokijs.service';
import {NewDocumentService} from '../../services/new-document.service';
import {TasksIconsService} from '../../services/workshopServices/tasks-icons.service';
import { LegacyJobHistoryDetailPage } from '../legacy-job-history-detail/legacy-job-history-detail.page';

@Component({
    selector: 'app-legacy-job-detail',
    templateUrl: './legacy-job-detail.page.html',
    styleUrls: ['./legacy-job-detail.page.scss'],
})
export class LegacyJobDetailPage implements OnInit {

    @Input() document: DocumentModel;
    @Input() jobList: ServiceJobDTOModel[];
    queryText = '';
    documentJobList: DocumentModel[] = [];

    constructor(private modalController: ModalController,
                private loki: LokijsService,
                private newDocumentService: NewDocumentService,
                private tasksIcons: TasksIconsService) {
    }

    ngOnInit() {
        // this.jobList = this.loki.getCollection('servicejob').chain().simplesort('documentNumber').data();
        // Wrap the jobList into New Documents
        console.log(this.documentJobList);
        for (const job of this.jobList) {
            this.documentJobList.push(this.newDocumentService.buildServiceJobDocumentBean(job));
        }
    }

    ionViewWillEnter() {
    }

    cancelService() {
        this.modalController.dismiss();
    }

    // formatDate(date: string) {
    //     return date.substr(8, 2) + '/' + date.substr(5, 2) + '/' + date.substr(0, 4);
    // }

    async openJobHistory(job: ServiceJobDTOModel) {
        const modal = await this.modalController.create({
            component: LegacyJobHistoryDetailPage,
            cssClass: 'modal-fullscreen',
            componentProps: {
                'job': job
            }
        });

        modal.onDidDismiss().then((dataReturned) => {
            if (dataReturned.data) {
            }
        });
        return await modal.present();

    }

    refreshDocs(event: CustomEvent<any>) {
        for (const job of this.jobList) {
            this.documentJobList.push(this.newDocumentService.buildServiceJobDocumentBean(job));
        }
        console.log(this.documentJobList);
    }

}
